import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import axios from "axios";
import { Autoplay, Navigation } from "swiper/modules";
import { Link, useParams } from "react-router-dom";

const MainPage = () => {
  const [slides, setSlides] = useState([]);
  const { restaurant, id } = useParams();

  const getSliderData = async () => {
    try {
      const res = await axios.post(
        `https://partnermeatwala.com/api/Vendor/GetSlider`,
        { pkid: id }
      );
      setSlides(res.data.sliders);
    } catch (error) {}
  };

  useEffect(() => {
    getSliderData();
  }, []);

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    const decodedText = txt.value;

    const strippedText = decodedText.replace(/<\/?[^>]+(>|$)/g, "");
    return strippedText;
  };

  return (
    <div className="th-hero-wrapper hero-3" id="hero">
      <div>
        <div className="row justify-content-end">
          <div className="col-xl-12">
            <Swiper
              effect="fade"
              pagination={{
                el: ".slider-pagination",
                clickable: true,
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay, Navigation]}
              className="th-slider"
            >
              {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="hero-inner"
                    style={{
                      backgroundImage: `url("https://partnermeatwala.com/documents/${slide.image}")`,
                      backgroundSize: "cover",
                    }}
                  >
                    <div className="hero-style3">
                      <span
                        className="hero-subtitle"
                        data-ani="slideinup"
                        data-ani-delay="0.0s"
                      >
                        {decodeHtml(slide.heading)}
                      </span>
                      <h1 className="hero-title2 text-white responsive-width">
  <span className="title1" data-ani="slideinup" data-ani-delay="0.2s">
    {decodeHtml(slide.heading)}
  </span>
</h1>

                      <p
                        className="hero-text text-white"
                        data-ani="slideinup"
                        data-ani-delay="0.5s"
                      >
                        {decodeHtml(slide.description)}
                      </p>
                      <Link
                        to={`/${restaurant}/${id}/menu`}
                        className="th-btn style4"
                        data-ani="slideinup"
                        data-ani-delay="0.6s"
                      >
                        ORDER NOW
                        <i className="fas fa-chevrons-right ms-2"></i>
                      </Link>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            {/* Pagination Controls */}
            <div className="slider-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPage;
